var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuLayout',{attrs:{"settingsMode":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }